import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { gql } from '@apollo/client'
import { Table, Alert, Button } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import '../Custom.css'
import { getData, getInputParams, currencyFormatter } from '../CustomUtils'
import { PLAINTIFF_DEFENSE_FEE_REPORT_QUERY } from '../../../graphql.js'
import ColumnHeadings from '../ColumnHeadings.js'
import ParameterValues from '../ParameterValues.js'
import ReportGrid from '../ReportGrid.js'
import { getTenant } from '../../../utils.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportHeading from '../ReportHeading.js'
import ReportTotalsRow from '../ReportTotalsRow.js'

const PLAINTIFF_DEFENSE_FEE_REPORT = gql(PLAINTIFF_DEFENSE_FEE_REPORT_QUERY)

export default function PlaintiffDefenseFeeReport({ location }) {
  console.log('PlaintiffDefenseFeeReport rendered:', location)

  const inputs = getInputParams(location)
  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  function detailLink(data) {
    const detailInputs = { plaintiffId: data, orderBy: '1', orderDir: 'ASC' }
    if (inputs.paidDateFrom) {
      detailInputs.paidDateFrom = inputs.paidDateFrom
    }
    if (inputs.paidDateTo) {
      detailInputs.paidDateTo = inputs.paidDateTo
    }
    const href = `/custom/plaintiff.list_invoices?inputs=${JSON.stringify(detailInputs)}`
    return <Link to={href} target="_blank"><Button color="primary" size="sm">View Invoices</Button></Link>
  }

  useEffect(() => {
    getData(location, PLAINTIFF_DEFENSE_FEE_REPORT, 'plaintiffDefenseFeeReport', setResults, setGraphQLErrors)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const csvUrl = `${process.env.REACT_APP_SERVER}/csv/${getTenant()}/custom/Asbestos/plaintiffDefenseFeeReport/plaintiff_defense_fees.csv?inputs=${JSON.stringify(inputs)}`
    const totalColumns = [
      { columnNumber: 9 },
      { columnNumber: 10 },
      { columnNumber: 11 }
    ]
    const columnFormatters = [
      { columnNumber: 9, formatter: currencyFormatter().format, align: 'right' },
      { columnNumber: 10, formatter: currencyFormatter().format, align: 'right' },
      { columnNumber: 11, formatter: currencyFormatter().format, align: 'right' },
      { columnNumber: 12, formatter: detailLink, align: 'center' },
    ]
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{backgroundColor: 'white'}} >
          <ReportHeading title='Plaintiff Defense Fee Report' parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} />
            <ReportGrid results={results} columnFormatters={columnFormatters} />
            <ReportTotalsRow reportData={results.reportData} totalColumns={totalColumns} />
          </tbody>
        </Table>
      </div>
    )
  }
}